import { type OperatorChatMacroT } from './types';

export const macroAvailable = (macro: OperatorChatMacroT, operator: GlassUserInfo) => {
  if (!macro.requires) {
    return true;
  }

  return macro.requires.every((key) => operator[key]);
};
